/* TYPE_SETTINGS */
export const GET_TYPE_SETTINGS = "GET_TYPE_SETTINGS"
export const GET_TYPE_SETTINGS_SUCCESS = "GET_TYPE_SETTINGS_SUCCESS"
export const GET_TYPE_SETTINGS_FAIL = "GET_TYPE_SETTINGS_FAIL"

/* TYPE_SETTINGS PROFILE */
export const GET_TYPE_SETTING_PROFILE = "GET_TYPE_SETTING_PROFILE"
export const GET_TYPE_SETTING_PROFILE_SUCCESS = "GET_TYPE_SETTING_PROFILE_SUCCESS"
export const GET_TYPE_SETTING_PROFILE_FAIL = "GET_TYPE_SETTING_PROFILE_FAIL"

/**
 * add TYPE_SETTING
 */
 export const ADD_NEW_TYPE_SETTING = "ADD_NEW_TYPE_SETTING"
 export const ADD_TYPE_SETTING_SUCCESS = "ADD_TYPE_SETTING_SUCCESS"
 export const ADD_TYPE_SETTING_FAIL = "ADD_TYPE_SETTING_FAIL"

 /**
 * Edit TYPE_SETTING
 */
export const UPDATE_TYPE_SETTING = "UPDATE_TYPE_SETTING"
export const UPDATE_TYPE_SETTING_SUCCESS = "UPDATE_TYPE_SETTING_SUCCESS"
export const UPDATE_TYPE_SETTING_FAIL = "UPDATE_TYPE_SETTING_FAIL"

/**
 * Delete TYPE_SETTING
 */
export const DELETE_TYPE_SETTING = "DELETE_TYPE_SETTING"
export const DELETE_TYPE_SETTING_SUCCESS = "DELETE_TYPE_SETTING_SUCCESS"
export const DELETE_TYPE_SETTING_FAIL = "DELETE_TYPE_SETTING_FAIL"


